import { defineComponent as _defineComponent } from 'vue'
import Action, { ActionProps } from "@/components/atoms/action/Action.vue";
import Badge, { BadgeProps } from "@/components/atoms/badge/Badge.vue";
import MiniCardMetrics, { Metric } from "@/components/molecules/card/MiniCardMetrics.vue";

export interface MiniCardProps {
    icon?: string;
    title?: string;
    subtitle?: string;
    badge?: BadgeProps;
    metrics?: Metric[];
    footer?: string;
    actions?: ActionProps[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniCard',
  props: {
    icon: null,
    title: null,
    subtitle: null,
    badge: null,
    metrics: null,
    footer: null,
    actions: null
  },
  setup(__props: any) {



return { __sfc: true,Action, Badge, MiniCardMetrics }
}

})